import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { useLocale } from '../../i18n/locale-context.js';
import { IconButton } from '../icon-button/IconButton.js';
import { Info, OctagonAlert, TriangleAlert, X } from '../../icons/index.js';
const VARIANT_CLASSES = {
    info: 'bg-status-info-tint-bg text-status-info-tint-fg',
    warning: 'bg-status-warning-tint-bg text-status-warning-tint-fg',
    critical: 'bg-status-critical-tint-bg text-status-critical-tint-fg',
};
const VARIANT_ICON = {
    info: Info,
    warning: TriangleAlert,
    critical: OctagonAlert,
};
export function AlertBanner({ variant, title, children, onDismiss, action }) {
    const { t } = useLocale();
    const VariantIcon = VARIANT_ICON[variant];
    return (_jsxs("div", { role: variant === 'critical' ? 'alert' : 'status', "aria-live": "polite", className: cn('flex gap-3 rounded-md p-4', VARIANT_CLASSES[variant]), children: [_jsx(VariantIcon, { "aria-hidden": "true", width: 20, height: 20, className: "mt-0.5 shrink-0" }), _jsxs("div", { className: "flex-1", children: [_jsx("p", { className: "font-semibold", children: title }), children ? _jsx("div", { className: "mt-1 text-sm", children: children }) : null, action ? _jsx("div", { className: "mt-2", children: action }) : null] }), onDismiss ? (_jsx(IconButton, { label: t('common.dismiss'), icon: _jsx(X, { width: 16, height: 16 }), onClick: onDismiss, className: "text-current hover:bg-black/5" })) : null] }));
}
//# sourceMappingURL=AlertBanner.js.map